import { render, staticRenderFns } from "./OrderCompletionModal.vue?vue&type=template&id=773e6764"
import script from "./OrderCompletionModal.vue?vue&type=script&lang=ts"
export * from "./OrderCompletionModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports